var config = {
  apiBaseUrl: process.env.API_URL,
  wpBaseUrl: "/wp-content/themes/college-weekends/app/",
  fileBaseUrl: "https://collegeweekends.blob.core.windows.net/listing-container",
  googleMapsApiKey: "AIzaSyA0mC3cOH79vug6tjTA53egXdH9icKwGjQ",
  googleLoginClientId: "878368942346-u196mh5lhhj4kichijvrrn98anegnjb4.apps.googleusercontent.com",
  facebookLoginAppId: "1048153552426912",
  affirmEnabled: true,
  affirmKey: "IMT0I48A1YI9MAMT"
};

module.exports = config;
